import { CoreListItem, CoreSingleItem } from "../Misc/List/CoreListItem";

export class PreCacheItem extends CoreListItem<SinglePreCacheItem> {
}

export class SinglePreCacheItem extends CoreSingleItem {
    type: PrecacheItemType;
    src: string;
}

export enum PrecacheItemType {
    Image,
    Video,
    Audio
}